import React from "react";
import "../Spaces/Spaces.css";

const Spaces = () => {
  return (
    <div className="spaces">
      <div className="s-left">
        <div className="heading-bar">
          <h3 className="heading-text">Exclusive Office Spaces</h3>
        </div>
        <div className="overlay-s">
          <img src="office.webp" alt="Space Left" className="space-img" />
          <h2 className="overlay-text-s">
            Sizes Starts From 419 Sqft. Onwards
          </h2>
        </div>
      </div>
      <div className="s-right">
        <div className="heading-bar">
          <h3 className="heading-text">Exclusive Anchor Spaces</h3>
        </div>
        <div className="overlay-s">
          <img src="anchor.webp" alt="Space Right" className="space-img" />
          <h2 className="overlay-text-s">
            Anchor Shops Sizes Starts From 100 Sqft.
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Spaces;
